/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Discount,
    DiscountFromJSON,
    DiscountToJSON,
    DiscountCreateParams,
    DiscountCreateParamsFromJSON,
    DiscountCreateParamsToJSON,
    DiscountCreateParamsV2,
    DiscountCreateParamsV2FromJSON,
    DiscountCreateParamsV2ToJSON,
    DiscountList,
    DiscountListFromJSON,
    DiscountListToJSON,
    DiscountListV2,
    DiscountListV2FromJSON,
    DiscountListV2ToJSON,
    DiscountV2,
    DiscountV2FromJSON,
    DiscountV2ToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface CreateDiscountRequest {
    program_id: string;
    order_id: string;
    DiscountCreateParams: DiscountCreateParams;
}

export interface CreateDiscountV2Request {
    program_id: string;
    order_id: string;
    DiscountCreateParamsV2: DiscountCreateParamsV2;
}

export interface DeleteDiscountRequest {
    program_id: string;
    order_id: string;
    id: string;
}

export interface DeleteDiscountV2Request {
    program_id: string;
    order_id: string;
    id: string;
}

export interface FindDiscountsRequest {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindDiscountsV2Request {
    program_id: string;
    order_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
}

export interface FindOneDiscountRequest {
    program_id: string;
    order_id: string;
    id: string;
}

export interface FindOneDiscountV2Request {
    program_id: string;
    order_id: string;
    id: string;
}

/**
 * 
 */
export class DiscountsApi extends runtime.BaseAPI {

    /**
     * @deprecated Create discount
     */
    async createDiscountRaw(requestParameters: CreateDiscountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Discount>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createDiscount.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling createDiscount.');
        }

        if (requestParameters.DiscountCreateParams === null || requestParameters.DiscountCreateParams === undefined) {
            throw new runtime.RequiredError('DiscountCreateParams','Required parameter requestParameters.DiscountCreateParams was null or undefined when calling createDiscount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/discounts`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscountCreateParamsToJSON(requestParameters.DiscountCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountFromJSON(jsonValue));
    }

    /**
     * @deprecated Create discount
     */
    async createDiscount(requestParameters: CreateDiscountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Discount> {
        const response = await this.createDiscountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create discount
     */
    async createDiscountV2Raw(requestParameters: CreateDiscountV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<DiscountV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createDiscountV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling createDiscountV2.');
        }

        if (requestParameters.DiscountCreateParamsV2 === null || requestParameters.DiscountCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('DiscountCreateParamsV2','Required parameter requestParameters.DiscountCreateParamsV2 was null or undefined when calling createDiscountV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/discounts`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscountCreateParamsV2ToJSON(requestParameters.DiscountCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountV2FromJSON(jsonValue));
    }

    /**
     * Create discount
     */
    async createDiscountV2(requestParameters: CreateDiscountV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<DiscountV2> {
        const response = await this.createDiscountV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Delete discount
     */
    async deleteDiscountRaw(requestParameters: DeleteDiscountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteDiscount.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling deleteDiscount.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDiscount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/discounts/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Delete discount
     */
    async deleteDiscount(requestParameters: DeleteDiscountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteDiscountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete discount
     */
    async deleteDiscountV2Raw(requestParameters: DeleteDiscountV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteDiscountV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling deleteDiscountV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDiscountV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/discounts/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete discount
     */
    async deleteDiscountV2(requestParameters: DeleteDiscountV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteDiscountV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated List all discounts
     */
    async findDiscountsRaw(requestParameters: FindDiscountsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<DiscountList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findDiscounts.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findDiscounts.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/discounts`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountListFromJSON(jsonValue));
    }

    /**
     * @deprecated List all discounts
     */
    async findDiscounts(requestParameters: FindDiscountsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<DiscountList> {
        const response = await this.findDiscountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all discount
     */
    async findDiscountsV2Raw(requestParameters: FindDiscountsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<DiscountListV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findDiscountsV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findDiscountsV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/discounts`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountListV2FromJSON(jsonValue));
    }

    /**
     * List all discount
     */
    async findDiscountsV2(requestParameters: FindDiscountsV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<DiscountListV2> {
        const response = await this.findDiscountsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find discount by id
     */
    async findOneDiscountRaw(requestParameters: FindOneDiscountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Discount>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneDiscount.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneDiscount.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneDiscount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/orders/{order_id}/discounts/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountFromJSON(jsonValue));
    }

    /**
     * @deprecated Find discount by id
     */
    async findOneDiscount(requestParameters: FindOneDiscountRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Discount> {
        const response = await this.findOneDiscountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find discount by id
     */
    async findOneDiscountV2Raw(requestParameters: FindOneDiscountV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<DiscountV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneDiscountV2.');
        }

        if (requestParameters.order_id === null || requestParameters.order_id === undefined) {
            throw new runtime.RequiredError('order_id','Required parameter requestParameters.order_id was null or undefined when calling findOneDiscountV2.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneDiscountV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/orders/{order_id}/discounts/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters.order_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountV2FromJSON(jsonValue));
    }

    /**
     * Find discount by id
     */
    async findOneDiscountV2(requestParameters: FindOneDiscountV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<DiscountV2> {
        const response = await this.findOneDiscountV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
